import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { 
  Button, 
  Alert,
  Box, 
  Typography, 
  Divider,
  TextField,
  LinearProgress,
  Fade,
  Select,
  MenuItem,
  Tooltip,
  IconButton
} from '@mui/material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

import { Orders, Shippings, Parts, Logger } from '../../../controllers';
import { Confirmation } from '../../utils';
import { CONST, TokenValidator, LoggerUtils} from '../../../utils';

export default function Main() {
    const nav = useNavigate();

    const [shared, SetShared] = React.useState([]);
    const [boxes, SetBoxes] = React.useState([]);

    const [order, setOrder] = React.useState('');
    const [orderInfo, SetOrderInfo] = React.useState(undefined);
    
    const [shareOrder, SetSharedOrder] = React.useState(false);
    const [reprint, SetReprint] = React.useState(false);
    const [holded, SetHolded] = React.useState(false);
    const [shippingHold, SetShippingHold] = React.useState(null);

    const [preload, SetPreload] = React.useState(0);
    const [dimensions, SetDimensions] = React.useState({x:0, y:0, z:0, w:0});
    const [service, SetService] = React.useState(0);

    const [confirm, ShowConfirm] = React.useState(false);
    const [confirmMsg, SetConfirmMsg] = React.useState('A Shipping Label will be created. Do you want to proceed?');

    React.useEffect(() =>{
        init();
    },[]);

    React.useEffect(() => {
        if(preload === 0){
            return;
        }
        handlePreload();
    },[preload]);

    const init = async() => {
        await GetSharedBoxes();
        await GetDefaultBoxes();
    }

    const GetSharedBoxes = async() => {
        const response = await Shippings.GetSharedBoxes();

        if(!response){
            console.log('Error loading Shared boxes');
            return;
        }

        const result = response.found ? response.result : [];

        SetShared(result);
    }

    const GetDefaultBoxes = async() => {
        const response = await Shippings.GetDefaultBoxes();

        if(!response){
            console.log('Error loading Default boxes');
            return;
        }

        const result = response.found ? response.result : [];

        SetBoxes(result);
    }


    const handleFetch = async(e) => {
        e.preventDefault();
        await starPocessing();
        setOrder('');
    }

    const starPocessing = async() => {
        SetShippingHold(null);
        const orderInfoReponse = await getOrderInfo();
        
        if(orderInfoReponse === undefined){
            SetOrderInfo(undefined);
            return;
        }

        const labelHoldResponse = await Shippings.GetLabelHold(orderInfoReponse.id);
        if(!labelHoldResponse || !labelHoldResponse.success){
            alert('Unable to validate Shipping Hold. Reload and try again.');
            SetOrderInfo(undefined);
            return;
        }
        const activeShippingHold = labelHoldResponse.active ? labelHoldResponse.result : null;
        SetShippingHold(activeShippingHold);

        const client = orderInfoReponse.data_general.case_client.toLowerCase().replaceAll(" ","");
        const inShared = shared.some(x => x.data_general.clients.includes(client));
        const groupShared = shared.findIndex(x => x.data_general.clients.includes(client));
        const totalShared = await getGroupTotals(shared[groupShared]);
        const costShared = inShared ? shared[groupShared].data_general.costs[client] : 0;
        
        console.log (client, inShared, groupShared, totalShared, costShared);

        if(inShared){

            if(shared[groupShared].data_general.limit < (totalShared + costShared) ){
                alert(`BOX FULL \nPrint Box label to continue.`);
                return ;
            }

            const holderResponse = await Shippings.GetHoldOrder(orderInfoReponse.id);
            
            if(holderResponse === undefined){
                alert('Error fetching order information. Please, try again');
                return;
            }

            if(!holderResponse.success){
                alert('Not succes fetching order information. Please, try again');
                console.log('Error on Success:', holderResponse.error);
                return;
            }

            const isHold = holderResponse.found;

            SetHolded(isHold);
            SetConfirmMsg(`The order will be added to the Client Batch : ${orderInfoReponse.data_general.case_client} \nDo you want to proceed?`);
        }else{
            const shippings = await getShippings();
            const isReprint = !(shippings === undefined);
            SetReprint(isReprint);
            SetConfirmMsg(`A Shipping Label will be ${isReprint ? 'reprinted' : 'created'}. Do you want to proceed?`);
        }

        SetSharedOrder(inShared)
        SetOrderInfo({...orderInfoReponse});
    }

    const getOrderInfo = async() => {
        const result = await Orders.GetById(parseInt(order));
        if(!result.success){
            alert(result.message);
            return undefined;
        }
        return result.result;
    }

    const getGroupTotals = async(group) => {
        if(!group){
            return 0;
        }
        
        let result = 0;
        const clients = group.data_general.clients;
        const counters = group.client_counters;
        const costs = group.data_general.costs;

        if(counters == undefined){
            return 0;
        }

        counters.forEach(x => result += clients.includes(x.name) ? x.counter * costs[x.name] : 0);

        return result;
    }

    const getShippings = async() => {
        const result = await Shippings.GetSingleShip(parseInt(order));
        if(!result.success){
            alert('Error loading order info. Try again');
            return undefined;
        }

        if(!result.found){
            return undefined;
        }

        return result.result;
    }

    const handlePreload = async() => {
        const element = boxes.find(x => x.id === preload);
        const data = element.data_general.dimensions;
        const result = {
            x: data.width,
            y: data.height,
            z: data.length,
            w: data.weight,
        }
        SetDimensions(result);
    }

    const handleManual = async(e) => {
        e.preventDefault();
        const target = e.target.name;
        const value = e.target.value;

        if(isNaN(Number(value))){
            return;
        }
        SetDimensions({...dimensions, [target]:value});
    }

    const handleConfirm = async(e) => {
        e.preventDefault();
        ShowConfirm(false);

        if(shippingHold && (shareOrder || !reprint)){
            alert(`Shipping label creation is on hold for Order ${orderInfo.id}.`);
            return;
        }

        if(!reprint && !shareOrder){
            let valid = true;
            Object.keys(dimensions).forEach(x => {
                if(dimensions[x] <= 0){
                    valid = false;
                }
            });

            if(!valid){
                alert('Invalid Box Configuration');
                return;
            }

            if(service === 0){
                alert('Service Must be Selected');
                return;
            }
        }

        if(shareOrder){
            await handleShared();
        } else {
            await handleSingle();
        }

        SetOrderInfo(undefined);
    }

    const handleSingle = async() => {

        if(!reprint){
            const createResult = await createShipping();

            if(createResult === undefined){
                alert('Error processing Creation request.');
                return;
            }

            if(!createResult.success){
                alert(createResult.message);
                return;
            }
        }

        const printer = localStorage.getItem(CONST.STORAGE_KEYS.SHIPPING_OPEN_PRINTER);

        if(printer === null){
            alert('No printer is selected for the station. Check configuration.');
            return;
        }
        
        if(Number(printer) < 1){
            alert('No printer is selected for the station. Check configuration.');
            return;
        }

        const printResults = await Shippings.PrintOrder(orderInfo.id, Number(printer));
        console.log(printResults);
        if(printResults === undefined){
            alert('Error processing Label Print request.');
            return;
        }

        if(!printResults.success){
            alert(printResults.message);
            return;
        }

        if(!reprint){
            await handleStatusUpdate();
        }
        
        alert(`Order ${reprint ? 'reprinted' : 'created & printed'} successfully`);
    }

    const handleShared = async() => {
        if(holded){
            alert('Order already in hold for Batch');
            return;
        }

        const payload = {
            order : orderInfo.id
        }

        const response = await Shippings.AddHoldOrder(payload);
        
        if(response === undefined){
            alert('Error processing Add to Batch request.');
            return;
        }

        if(!response.success){
            alert('Error adding to batch. Please, try again');
            console.log('Error adding to batch: ', response.error);
            return;
        }

        await handleStatusUpdate();
        alert(`Order added to batch successfully`);
    }

    //region handleStatusUpdate
    const handleStatusUpdate = async() => {
        const status = 'Shipping Init';
        const partsFetch = await Parts.GetDetailFullByOrder(orderInfo.id);
        const parts = partsFetch.result;
        const token = await TokenValidator.GetStaffUser();
                
        for(const part of parts){
            const payload = {
                id          : part.id,
                status      : status,
            }

            await Parts.UpdateStatus(token, payload);
            const log = await LoggerUtils.PayloadCreator( 'Update', 'Autamation Status Update', 'Part processed packaging area successfully');
            await Logger.Part(part.id, log);
        }
    }

    const createShipping = async() => {
        const payload = {
            order: orderInfo,
            dimensions: dimensions,
            service: CONST.UPS_SERVICES.find(x => x.code === service)
        };

        const response = await Shippings.CreateSingle(payload);

        return response;
    }

    return(
        <Box
            sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                padding:1
            }}
        >
            <Confirmation 
                open={confirm}
                onClose={() => ShowConfirm(false)}
                onConfirm={handleConfirm}
                title='Create Shipping Label'
                msg={confirmMsg}
            />
            
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Typography component="h1" variant="h5">
                    Single & Batch Box Opening Dashboard
                </Typography>
                
                <Button color='primary' onClick={()  => nav(-1)}> <KeyboardReturnIcon/> RETURN</Button>
            </Box>

            <Divider sx={{minWidth:'100%'}}></Divider>
            
            <Box 
                component='form'
                onSubmit={handleFetch}
            >
                <TextField
                    size='small'
                    margin="normal"
                    required
                    fullWidth
                    label="Enter Order ID"
                    id="order"
                    name="order"
                    autoFocus
                    value={order}
                    onChange={e => setOrder(e.target.value)}
                />
            </Box>

            <br/>

            {orderInfo != undefined && (
                <Box>
                    <Typography component="h1" variant="h5">
                        Order Info
                    </Typography>
                    <Divider sx={{minWidth:'100%'}}></Divider>
                    <Box
                        sx={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent: 'space-evenly',
                            gap: 1
                        }}
                    >
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Order ID"
                            autoFocus
                            value={orderInfo.id}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Case ID"
                            autoFocus
                            value={orderInfo.case_serial}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Client"
                            autoFocus
                            value={orderInfo.data_general.case_client}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Is Batch Box?"
                            autoFocus
                            value={shareOrder ? 'Yes' : 'No'}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>
                </Box>
            )}  

            <br/>

            {orderInfo != undefined && shippingHold && (
                <Alert severity='warning' sx={{marginBottom:2}}>
                    Shipping Hold is active for this order. Creating a new individual or batch label is blocked. {reprint && !shareOrder ? 'The existing label may still be reprinted.' : ''}
                </Alert>
            )}

            {(orderInfo != undefined && !shareOrder) && (
                <Box>
                    <Typography component="h1" variant="h5">
                        Package Set-up
                    </Typography>
                    <Divider sx={{minWidth:'100%', marginBottom:2}}></Divider>

                    <Typography variant='button'>
                        Box Pre-Build Configs
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap:2,
                            marginBottom:2
                            }}
                    >
                        <Select
                            sx={{
                                width:'100%'
                            }}
                            id="kind"
                            name='kind'
                            value={preload}
                            onChange={(e) => SetPreload(e.target.value)}
                            autoFocus
                            size='small'
                            disabled={reprint}
                        >
                            <MenuItem key={0} value={0} selected>Select Pre-build Box</MenuItem>

                            {boxes.map((value, i) => (
                                <MenuItem key={i} value={value.id}>{value.client}</MenuItem>
                            ))}

                        </Select>
                    </Box>
                    

                    <Typography variant='button'>
                        Box Configuration
                    </Typography>

                    <Box
                        sx={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent: 'space-evenly',
                            gap: 1,
                            marginBottom:2
                        }}
                    >
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Width"
                            name='x'
                            value={dimensions.x}
                            onChange={handleManual}
                            disabled={reprint}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Height"
                            name='y'
                            value={dimensions.y}
                            onChange={handleManual}
                            disabled={reprint}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Lenght"
                            name='z'
                            value={dimensions.z}
                            onChange={handleManual}
                            disabled={reprint}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="Weight"
                            name='w'
                            value={dimensions.w}
                            onChange={handleManual}
                            disabled={reprint}
                        />
                    </Box>
                    
                    <Box
                        sx={{
                            marginBottom:2
                        }}
                    >
                        <Typography variant='button'>
                            Service Options
                        </Typography>

                        <Select
                            sx={{
                                width:'100%'
                            }}
                            id="kind"
                            name='kind'
                            value={service}
                            onChange={(e) => SetService(e.target.value)}
                            autoFocus
                            size='small'
                            disabled={reprint}
                        >
                            <MenuItem key={0} value={0} selected>Select Service</MenuItem>

                            {CONST.UPS_SERVICES.filter(x => x.active).map((value, i) => (
                                <MenuItem key={i+1} value={value.code}>{value.desc}</MenuItem>
                            ))}

                        </Select>
                    </Box>

                    <Button variant='contained' fullWidth disabled={Boolean(shippingHold)&&!reprint} onClick={() => ShowConfirm(true)}> {shippingHold&&!reprint?'Shipping Hold Active':!reprint ? 'Create' : 'Reprint'} Shipping Label </Button>

                </Box>
            )}

            {(orderInfo != undefined && shareOrder) && (
                <Box>
                    <Button variant='contained' fullWidth disabled={Boolean(shippingHold)} onClick={() => ShowConfirm(true)}> {shippingHold?'Shipping Hold Active':'Add order to Batch'} </Button>
                </Box>
            )}

        </Box>
    );
}
